import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload, SYNC_SUFFIX } from "@obg/ngrx-utils";

import { AppError } from "../app-error/app-error.model";

import {
	AamsBalance,
	AamsBalancesPayload,
	Balance,
	Balances,
	BalanceTimestamp,
	BetWinSummary,
	Transaction,
	TransactionDetail,
	TransactionFilter,
	TransactionTotalsError,
	TransactionTotalsFilter,
	TransactionTotalsRequest,
	TransactionTotalsResponse,
	WithdrawalRestrictions,
} from "./wallet.model";

export const ACTION_PREFIX = "[Wallet]";
export const WALLET_ACTION_TYPE = {
	getBalance: `${ACTION_PREFIX} Get Balance`,
	getBalanceSuccess: `${ACTION_PREFIX} Get Balance Success`,
	getGrBalanceSuccess: `${ACTION_PREFIX} Get Greece Balance Success`,
	getBalanceFail: `${ACTION_PREFIX} Get Balance Fail`,

	updateBalanceTimestamp: `${ACTION_PREFIX} Update balance timestamp ${SYNC_SUFFIX}`,

	enablePolledBalance: `${ACTION_PREFIX} Enable polled balance ${SYNC_SUFFIX}`,
	disablePolledBalance: `${ACTION_PREFIX} Disable polled balance ${SYNC_SUFFIX}`,

	enableRealtimeBalance: `${ACTION_PREFIX} Enable real time balance ${SYNC_SUFFIX}`,

	updateRealtimeStatus: `${ACTION_PREFIX} Update Realtime Status ${SYNC_SUFFIX}`,

	getBetWinSummary: `${ACTION_PREFIX} Get Bet Win Summary`,
	getBetWinSummarySuccess: `${ACTION_PREFIX} Get Bet Win Summary Success`,
	getBetWinSummaryFail: `${ACTION_PREFIX} Get Bet Win Summary Fail`,

	getTransactions: `${ACTION_PREFIX} Get Transactions`,
	getTransactionsSuccess: `${ACTION_PREFIX} Get Transactions Success`,
	getTransactionsFail: `${ACTION_PREFIX} Get Transactions Fail`,

	getTransaction: `${ACTION_PREFIX} Get Transaction`,
	getTransactionSuccess: `${ACTION_PREFIX} Get Transaction Success`,
	getTransactionFail: `${ACTION_PREFIX} Get Transaction Fail`,

	getTransactionTotals: `${ACTION_PREFIX} Get Transaction Totals`,
	getTransactionTotalsSuccess: `${ACTION_PREFIX} Get Transaction Totals Success`,
	getTransactionTotalsFail: `${ACTION_PREFIX} Get Transaction Totals Fail`,

	clearTransactions: `${ACTION_PREFIX} Clear Transactions ${SYNC_SUFFIX}`,

	updateCurrentProductBalance: `${ACTION_PREFIX} Update current product balance ${SYNC_SUFFIX}`,
	reset: `${ACTION_PREFIX} Reset ${SYNC_SUFFIX}`,

	getWithdrawalRestrictions: `${ACTION_PREFIX} Get Withdrawal Restriction ${SYNC_SUFFIX}`,
	getWithdrawalRestrictionsSuccess: `${ACTION_PREFIX} Get Withdrawal Restriction Success ${SYNC_SUFFIX}`,
	getWithdrawalRestrictionsFail: `${ACTION_PREFIX} Get Withdrawal Restriction Fail ${SYNC_SUFFIX}`,
};

export const DEFAULT_TRANSACTIONTOTALS_ID = "DefaultTransactionTotals";
/**
 * @deprecated [fabric-deprecated] - Use wallet-service from app-wallet instead
 */
@Injectable({
	providedIn: "root",
})
export class WalletAction {
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetWalletBalance instead
	 */
	getBalance(): Action {
		return {
			type: WALLET_ACTION_TYPE.getBalance,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetWalletBalance instead
	 */
	getBalanceSuccess(balance: Balances | AamsBalancesPayload): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getBalanceSuccess,
			payload: balance,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetWalletBalance instead
	 */
	getBalanceFail(response: AppError): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getBalanceFail,
			payload: response,
		};
	}

	enablePolledBalance(): Action {
		return {
			type: WALLET_ACTION_TYPE.enablePolledBalance,
		};
	}

	disablePolledBalance(): Action {
		return {
			type: WALLET_ACTION_TYPE.disablePolledBalance,
		};
	}

	enableRealtimeBalance(sessionToken: string): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.enableRealtimeBalance,
			payload: sessionToken,
		};
	}

	updateRealtimeStatus(): Action {
		return {
			type: WALLET_ACTION_TYPE.updateRealtimeStatus,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetBetWinSummary  instead
	 */
	getBetWinSummary(minutes: number): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getBetWinSummary,
			payload: minutes,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetBetWinSummary  instead
	 */
	getBetWinSummarySuccess(betWinSummary: BetWinSummary): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getBetWinSummarySuccess,
			payload: betWinSummary,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetBetWinSummary  instead
	 */
	getBetWinSummaryFail(response: AppError): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getBetWinSummaryFail,
			payload: response,
		};
	}

	getTransaction(): Action {
		return {
			type: WALLET_ACTION_TYPE.getTransaction,
		};
	}

	getTransactionSuccess(transaction: TransactionDetail): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getTransactionSuccess,
			payload: transaction,
		};
	}

	getTransactionFail(response: AppError): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getTransactionFail,
			payload: response,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetTransaction instead
	 */
	getTransactions(filter: TransactionFilter): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getTransactions,
			payload: filter,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetTransaction instead
	 */
	getTransactionsSuccess(transaction: Transaction): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getTransactionsSuccess,
			payload: transaction,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetTransaction instead
	 */
	getTransactionsFail(response: AppError): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getTransactionsFail,
			payload: response,
		};
	}
	/**
	 * @deprecated Use getTransactionTotals2
	 */
	getTransactionTotals(filter: TransactionTotalsFilter): ActionWithPayload {
		return this.getTransactionTotals2({ id: DEFAULT_TRANSACTIONTOTALS_ID, filter });
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetTransactionTotals instead
	 */
	getTransactionTotals2(request: TransactionTotalsRequest): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getTransactionTotals,
			payload: request,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetTransactionTotals instead
	 */
	getTransactionTotalsSuccess(response: TransactionTotalsResponse): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getTransactionTotalsSuccess,
			payload: response,
		};
	}
	/**
	 * @deprecated [fabric-deprecated] - Use WalletAppCommand.GetTransactionTotals instead
	 */
	getTransactionTotalsFail(response: TransactionTotalsError): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getTransactionTotalsFail,
			payload: response,
		};
	}

	clearTransactions(): Action {
		return {
			type: WALLET_ACTION_TYPE.clearTransactions,
		};
	}

	updateCurrentProductBalance(balance: Balance | AamsBalance): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.updateCurrentProductBalance,
			payload: balance,
		};
	}

	updateBalanceTimestamp(balance: BalanceTimestamp): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.updateBalanceTimestamp,
			payload: balance,
		};
	}

	reset(): Action {
		return {
			type: WALLET_ACTION_TYPE.reset,
		};
	}

	getWithdrawalRestriction(): Action {
		return {
			type: WALLET_ACTION_TYPE.getWithdrawalRestrictions,
		};
	}

	getWithdrawalRestrictionSuccess(withdrawalRestriction: WithdrawalRestrictions): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getWithdrawalRestrictionsSuccess,
			payload: withdrawalRestriction,
		};
	}

	getWithdrawalRestrictionFail(response: AppError): ActionWithPayload {
		return {
			type: WALLET_ACTION_TYPE.getWithdrawalRestrictionsFail,
			payload: response,
		};
	}
}
